<script lang="ts">
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {fly} from 'svelte/transition';

    export let itemsCount: number;
    export let currentIndex: number;
    export let setIndex: (value: number, calledFromEnd: boolean) => void;
</script>

<div class="kp-slider-controls">
    {#if currentIndex > 0}
        <button class="arrow-btn left"
                transition:fly={{x: -10}}
                on:click={() => setIndex(currentIndex - 1, false)}>

            <UIcon icon="arrow-small-left"/>
        </button>
    {/if}

    {#if currentIndex < itemsCount - 1}
        <button class="arrow-btn right"
                transition:fly={{x: 10}}
                on:click={() => setIndex(currentIndex + 1, false)}>

            <UIcon icon="arrow-small-right"/>
        </button>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    @arrow-btn-size: 38px;
    @arrow-icon-size: 18px;
    @arrow-offset: 20px;

    .arrow-btn {
        position: absolute;
        width: @arrow-btn-size;
        height: @arrow-btn-size;
        border-radius: 50%;
        outline: 1px solid transparent;
        outline-offset: 1px;
        background-color: @themed-body-bg;
        border: 1px solid @themed-border-default;
        font-size: @arrow-icon-size;
        display: flex;
        color: @themed-text-default;
        align-items: center;
        justify-content: center;
        top: 50%;
        transform: translate(-50%, -50%);
        box-shadow: rgba(0, 0, 0, 0.2) 0 3px 8px;
        transition: opacity 0.3s ease-in-out, border-color 0.3s ease-in-out, outline-color 0.3s ease-in-out, visibility 0.3s ease-in-out, transform 0.3s ease-in-out;

        &:hover,
        &:active {
            opacity: 0.85;
            outline-color: var(--accent-blue);
        }

        &:active {
            opacity: 0.65;
        }

        &.left {
            left: 0;
            transform: translate(calc(@arrow-offset * -1), -50%);
        }

        &.right {
            right: 0;
            transform: translate(@arrow-offset, -50%);
        }
    }
</style>